module.exports = "/assets/5612e138983c9da50341c371a205c73d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/LS.png
// module id = 2714
// module chunks = 0